import { getIn } from "formik";
import React from "react";
import { Form } from "react-bootstrap";

export default function CheckBoxField({field, form, required, ...props }) {
    const ErrorText = getIn(form.touched, field.name) && getIn(form.errors, field.name)
  return (
    <Form.Group className="mb-3">
      <Form.Check
        checked={field.value}
        //value={data?.firstname}
        isInvalid={Boolean(ErrorText)}
        {...field}
        {...props}
      />
      <Form.Control.Feedback type="invalid" tooltip>
        {ErrorText}
    </Form.Control.Feedback>
    </Form.Group>
  );
}
